import { ProfileStatusEnum } from "utils/enums/AppProfileEnum";

export class AppProfileRequestEntity {
  page?: number;
  limit?: number;
  status?: number;
  type?: number;
  code?: string;
  providerCode?: number;
  providerPreviewCode?: string;
  date?: Array<Record<string, unknown>>;
  phoneNumber?: string;
  isVerified?: boolean;
  fromDate?: string;
  toDate?: string;
  typeContract?: string;

  constructor(data?: Partial<AppProfileRequestEntity>) {
    Object.assign(this, data);
  }

  getIsVerifiedParam?(status: number) {
    switch (status) {
      case ProfileStatusEnum.Approved:
        return true;
      case ProfileStatusEnum.Approving:
        return false;
      default:
        return undefined;
    }
  }
}
